import { useToast } from '@/components/ui/use-toast';
import { useTranslations } from 'next-intl';

type CopyTypes = (text: string, successMessage?: string, errorMessage?: string) => void;

export const useClipboard = (): { copy: CopyTypes } => {
  const { toast } = useToast();

  const tCommon = useTranslations('common');

  const copy: CopyTypes = (
    text: string,
    successMessage = 'Copied to the clipboard!',
    errorMessage = 'Failed to copy to clipboard',
  ) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast({
          title: 'Success',
          description: successMessage,
        });
      })
      .catch(() => {
        toast({
          title: tCommon('error'),
          description: errorMessage,
        });
      });
  };

  return { copy };
};
